import React from 'react';
import { iconToEmoji } from '../utils/iconUtils';

const DrinkCard = ({ drink, onPurchase, isLoading, disabled }) => {
  const blocked = Boolean(disabled) || Boolean(isLoading);
  const handleClick = () => {
    if (!blocked) {
      onPurchase(drink.id);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={blocked}
      className={`drink-card ${
        blocked ? 'opacity-50 cursor-not-allowed' : ''
      }`}
    >
      <div className="flex items-center justify-between h-full p-4">
        <div className="flex items-center space-x-3">
          <div className="text-2xl">
            <img 
              src={`/icons/drinks/${drink.icon}`} 
              alt={drink.name} 
              className="w-6 h-6 object-contain"
              onError={(e) => {
                // Fallback auf Emoji wenn PNG nicht gefunden
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <span className="text-xl hidden">{iconToEmoji(drink.icon)}</span>
          </div>
          <div className="text-left">
            <div className="font-semibold text-bg-1 text-base">
              {drink.name}
            </div>
            <div className="text-sm text-bg-1/70">
              {drink.price} €
            </div>
          </div>
        </div>
        
        {isLoading && (
          <div className="animate-spin rounded-full h-5 w-5 border-2 border-accent-1 border-t-transparent"></div>
        )}
      </div>
    </button>
  );
};

export default DrinkCard; 